/* @flow */
import * as React from 'react';
import Row from 'components/Row';
import Text from 'components/Text';
import Input from 'components/Input';
import Glyph from 'components/Glyph';
import Heading from 'components/Heading';
import MediaObject from 'components/MediaObject';
import FormElement from 'components/FormElement';

import './styles/CanvasLTICredentials.scss';

type Props = {
  rotateOnMount: boolean,
  rotateCredentials: Function,
};

type State = {
  clientId: string,
  clientSecret: string,
};

class CanvasLTICredentials extends React.Component<Props, State> {
  state: State = {
    clientId: '',
    clientSecret: '',
  };

  componentDidMount() {
    if (this.props.rotateOnMount) {
      this.props
        .rotateCredentials()
        .then(e => {
          this.setState({
            clientId: e.clientId,
            clientSecret: e.clientSecret,
          });
        })
        .catch(e => {
          console.debug(e);
          console.error('could not generate canvas LTI credentials');
        });
    }
  }

  render() {
    return (
      <div className="CanvasLTICredentials">
        <Row>
          <Heading>Generate a new set of credentials</Heading>
        </Row>
        <div className="CanvasLTICredentials-box">
          <Row>
            <div className="CanvasLTICredentials-box-notice">
              <MediaObject center>
                <Glyph name="explanation-circle" size="xlarge" />
                <Text size="xsmall">
                  Record your username and password credentials in a secure and safe place. You will
                  not be able to see this username and password again.
                </Text>
              </MediaObject>
            </div>
          </Row>
          <FormElement
            element={Input}
            label="Consumer Key"
            elementProps={{ readOnly: true, value: this.state.clientId }}
          />

          <FormElement
            element={Input}
            label="Shared Secret"
            elementProps={{ readOnly: true, value: this.state.clientSecret }}
          />
        </div>
      </div>
    );
  }
}

export default CanvasLTICredentials;
